async function fetchCurrentTime(){
    const currentTimeSectionHtml = await fetch(window.Shopify.routes.root + '?section_id=current-time');
    const sectionHtml = await currentTimeSectionHtml.text();
    return new DOMParser().parseFromString(sectionHtml, 'text/html').getElementById('ktg-current-time').textContent;
}

async function fetchCurrentDate(){
    const currentTimeSectionHtml = await fetch(window.Shopify.routes.root + '?section_id=current-time');
    const sectionHtml = await currentTimeSectionHtml.text();
    return new DOMParser().parseFromString(sectionHtml, 'text/html').getElementById('ktg-current-date').textContent;
}

function showDefaultStage(){
    $('[data-tab-id="stage-1"]').addClass('active');
    $('#stage-1').addClass('active');
    $('#ktg-cart-loader').addClass('ktg-hide');
    $('#cart-tab-container').removeClass('ktg-hide');
}

function convertDateFormat(date){
  const [day, month, year] = date.split('/').map(number => number);
  return `${year}-${month}-${day}`;
}

async function compareDates(current, selected){
  const currentDate = new Date(current);
  const selectedDate = new Date(selected);
  const status = selectedDate <= currentDate ? false : true;
  return status;
}

async function getNextDay(date){
  const currentDate = new Date(date);
  currentDate.setDate(currentDate.getDate() + 1);
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Adding 1 to month as it's 0-indexed
  const day = String(currentDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function showSelectedStage(id){
    $(`[data-tab-id]`).removeClass('active');
    $(`[data-tab-id="${id}"]`).addClass('active');
    $('.ktg-tab').removeClass('active');
    $(`#${id}`).addClass('active');
    $('#ktg-cart-loader').addClass('ktg-hide');
    $('#cart-tab-container').removeClass('ktg-hide');
}

async function validateCurrentTime(){
  const currentDate = await fetchCurrentDate();
  const currentTime = await fetchCurrentTime();
  const todaysDayString = dayjs(currentDate).day() == 0 ? 'Day-7' : `Day-${dayjs(currentDate).day()}`;
  if(perDayThresoldTime[todaysDayString] == 'NA' || isNaN(perDayThresoldTime[todaysDayString])) return false;
  const theresoldTime = +perDayThresoldTime[todaysDayString];
  const status = currentTime < theresoldTime ? true : false;
  return status;
}

async function populateCartPageDataUsingSessionStorage(ktgCartData) {
  if(ktgCartData.postcodeDetails) stageOne.postcodeDetails = ktgCartData.postcodeDetails
  if(ktgCartData.deliveryDate) {
    stageOne.deliveryDate = ktgCartData.deliveryDate;
    $('#delievery-date').val(ktgCartData.deliveryDate);
    $('#delievery-date').attr('name', 'attributes[Delivery Date]');
  }
  else $('#delievery-date').removeAttr('name');

  if(ktgCartData.deliveryOption){
    stageOne.deliveryOption = ktgCartData.deliveryOption;
    $('#delievery-option').val(ktgCartData.deliveryOption);
    $('#delievery-option').attr('name', 'attributes[Delivery Option]');
  }
  else $('#delievery-option').removeAttr('name');
  
  if(ktgCartData.suburb){
    stageOne.suburb = ktgCartData.suburb;
    $('#delievery-suburb').val(ktgCartData.suburb);
    $('#delievery-suburb').attr('name', 'attributes[Suburb]');
  }
  else $('#delievery-suburb').removeAttr('name');
  
  if(ktgCartData.postcode){
    stageOne.postcode = ktgCartData.postcode;
    $('#delievery-postcode').val(ktgCartData.postcode);
    $('#delievery-postcode').attr('name', 'attributes[Postcode]');
  }
  else $('#delievery-postcode').removeAttr('name');
  
  if(ktgCartData.recipient_name){
    $('#gift-receiver').val(ktgCartData.recipient_name);
    $('#gift-receiver').attr('name', 'attributes[Recipient Name]');
  }
  else $('#gift-receiver').removeAttr('name');

  if(ktgCartData.sender_name){
    $('#gift-sender').val(ktgCartData.sender_name);
    $('#gift-sender').attr('name', 'attributes[Sender Name]');
  }
  else $('#delievery-sender').removeAttr('name');
  
  if(ktgCartData.note){
    $('#gift-message').val(ktgCartData.note);
    $('#gift-message').attr('name', 'attributes[Message]');
  }
  else $('#delievery-message').removeAttr('name');

  if(ktgCartData.cardTitle){
    $('#gift-card-title').val(ktgCartData.cardTitle);
    $('#gift-card-title').attr('name', 'attributes[Card Title]');
  }
  else $('#gift-card-title').removeAttr('name');
  
  var container = document.querySelector('#ktg-stage--data-content');
  container.innerHTML = '';
  container.insertAdjacentHTML('beforeend', 
      `<p><strong>Delivery Option:</strong> ${ktgCartData.deliveryOption}</p>` 
  );
  if (ktgCartData.deliveryDate && ktgCartData.deliveryDate !== "")
    container.insertAdjacentHTML('beforeend', `<p><strong>Delivery Date:</strong> ${ktgCartData.deliveryDate}</p>`);
  container.insertAdjacentHTML('beforeend', 
      `<p><strong>Delivery Location:</strong> ${ktgCartData.suburb}, ${ktgCartData.postcode}</p>`
  );
  if(ktgCartData.note){
    // container.insertAdjacentHTML('beforeend', `<h4>Your Message</h4>`);
    var senderName = ktgCartData.send_anonymously ? 'Anonymous' : '';
    var cardTitle = ktgCartData.cardTitle || '';
    container.insertAdjacentHTML('beforeend', 
        // `<p><strong>To:</strong> ${ktgCartData.recipient_name}</p>` +
        `<p><strong>Message:</strong> "${ktgCartData.note}"</p>` +
        `<p class="${!cardTitle ? 'ktg-hide' : ''}"><strong>Card Design:</strong> ${cardTitle}</p>`+
        `<p class="${!senderName ? 'ktg-hide' : ''}"><strong>From:</strong> ${senderName}</p>`
    );
  }
}

function scrollToTop() {
  const startPosition = {
    x: window.pageXOffset || document.documentElement.scrollLeft,
    y: window.pageYOffset || document.documentElement.scrollTop
  };

  const targetPosition = { x: 0, y: 0 };
  const distance = {
    x: targetPosition.x - startPosition.x,
    y: targetPosition.y - startPosition.y
  };

  const duration = 500;
  let start = null;

  function step(timestamp) {
    if (!start) start = timestamp;

    const progress = timestamp - start;
    const newX = easeInOutCubic(progress, startPosition.x, distance.x, duration);
    const newY = easeInOutCubic(progress, startPosition.y, distance.y, duration);

    window.scrollTo(newX, newY);

    if (progress < duration) {
      window.requestAnimationFrame(step);
    }
  }

  window.requestAnimationFrame(step);
}

function easeInOutCubic(t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t * t + b;
  t -= 2;
  return c / 2 * (t * t * t + 2) + b;
}
